@if (authService.isLoggingOut()) {
  <div class="layout-loading-overlay fixed inset-0" role="status" aria-live="polite" aria-busy="true">
    <pulse-loading-screen />
  </div>
}

<div class="layout" [class.layout--mobile-nav-open]="layoutService.isMobileNavOpen()">
  <pulse-navigation [navMenu]="navMenu()"></pulse-navigation>
  <pulse-topbar
    [brandLogoUrl]="navigationConfig().logoCollapsedUrl"
    [brandLogoAltText]="navigationConfig().logoAltText"
    [brandWordmarkUrl]="navigationConfig().logoExapandedUrl"
    [brandWordmarkAltText]="navigationConfig().logoAltText"></pulse-topbar>
  <div class="layout-content">
    <pulse-locale-setup-banner></pulse-locale-setup-banner>
    <pulse-header [config]="headerConfig()"></pulse-header>
    <main class="layout-main">
      <!-- "grow w-full" needed for the router-outlet components to take up the remaining space -->
      <div class="grow w-full">
        @if (layoutService.hasError()) {
          <p-message class="mb-3" severity="error" icon="fa-duotone fa-regular fa-circle-exclamation" closable>
            <!-- <span i18n>You are currently using <b>PRODUCTION</b> data in a <b>DEVELOPMENT</b> environment!</span> -->
            <span>{{ layoutService.getErrorMessage() }}</span>
          </p-message>
        }

        <router-outlet></router-outlet>
      </div>
    </main>
    <pulse-footer></pulse-footer>
  </div>

  <div class="layout-fab fixed right-4 bottom-4">
    <p-button icon="fa-regular fa-question" [raised]="true" [rounded]="true" (click)="supportMenuRef.toggle($event)"></p-button>
  </div>
</div>

<p-dialog class="w-23rem" i18n-header header="Cobrowse Code" closeIcon="fa-regular fa-xmark" [modal]="true" [(visible)]="layoutService.isCoBrowseDialogVisible">
  <span i18n class="p-text-secondary block mb-3">Only share this code with your PULSE support agent.</span>
  <div class="relative group flex flex-row justify-center p-3 mb-3 rounded-sm bg-slate-950">
    <span class="text-lg font-bold text-white">{{ coBrowseCode() }}</span>
    <p-button
      class="absolute hidden group-hover:block right-3 top-3"
      class="border-1 border-slate-700 border-color"
      icon="fa-duotone fa-solid fa-file"
      severity="contrast"
      (click)="copyCodeToClipboard()"></p-button>
  </div>
</p-dialog>

<p-toast [position]="baseConfig().toastPosition" [key]="loadingToastKey"></p-toast>
<p-toast [life]="baseConfig().toastDuration" [position]="baseConfig().toastPosition"></p-toast>

<p-menu #supportMenuRef [model]="supportMenu()" [popup]="true" />

<p-confirmdialog #cd>
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="flex flex-col items-center p-8 bg-surface-0">
      <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
      <p class="mb-0">{{ message.message }}</p>
      <div class="flex items-center gap-2 mt-6">
        <p-button [label]="message.acceptLabel" (onClick)="onAccept()"></p-button>
        <p-button [label]="message.rejectLabel" (onClick)="onReject()" severity="secondary"></p-button>
      </div>
    </div>
  </ng-template>
</p-confirmdialog>

<pulse-session-timeout-dialog></pulse-session-timeout-dialog>
